var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.4805,
    r: 24,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4779 29.5C18.6765 29.5 13.7222 30.3771 13.7222 33.89C13.7222 37.4029 18.645 38.3114 24.4779 38.3114C30.2793 38.3114 35.2322 37.4329 35.2322 33.9214C35.2322 30.41 30.3107 29.5 24.4779 29.5Z",
    stroke: "currentColor",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4776 24.4903C28.2848 24.4903 31.3705 21.4031 31.3705 17.596C31.3705 13.7888 28.2848 10.7031 24.4776 10.7031C20.6705 10.7031 17.5833 13.7888 17.5833 17.596C17.5705 21.3903 20.6362 24.4774 24.429 24.4903H24.4776Z",
    stroke: "#8A8A8A",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.86606aba636946bb9b4fe485c6a4153e.svg";
export { ForwardRef as ReactComponent };